export default "__VITE_ASSET__Drg$_KH___"